import Vue from 'vue'
import { Button, Form, Field, Switch, List, PullRefresh, Grid, GridItem, Tabbar, TabbarItem, Collapse, CollapseItem, RadioGroup, Radio, Uploader, Toast, NavBar, Icon, Cell, CellGroup, Panel, Row, Col, Search, Sticky, Checkbox, Tag, CheckboxGroup, SubmitBar, Picker, Popup, DropdownMenu, DropdownItem, Dialog } from 'vant'

export default function vant() {
    Vue.use(Button);
    Vue.use(Form);
    Vue.use(Field);
    Vue.use(Switch);
    Vue.use(List);
    Vue.use(PullRefresh);
    Vue.use(Tabbar);
    Vue.use(TabbarItem);
    Vue.use(Collapse);
    Vue.use(CollapseItem);
    Vue.use(RadioGroup);
    Vue.use(Radio);
    Vue.use(Uploader);
    Vue.use(Toast);
    Vue.use(NavBar);
    Vue.use(Icon);
    Vue.use(Cell);
    Vue.use(Panel);
    Vue.use(Search);
    Vue.use(Sticky);
    Vue.use(Checkbox);
    Vue.use(CheckboxGroup);
    Vue.use(SubmitBar);
    Vue.use(CellGroup);
    Vue.use(Picker);
    Vue.use(Popup);
    Vue.use(DropdownMenu);
    Vue.use(DropdownItem);
    Vue.use(Row);
    Vue.use(Col);
    Vue.use(Grid);
    Vue.use(GridItem);
    Vue.use(Tag);
    Vue.use(Dialog);
}


